import React from "react";
import aboutimg from "../../assets/AboutusImage.png";

const AboutUs = () => {
  return (
    <div className="py-10 px-3 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
            About Us
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-2"></div>
          </h2>
          <p className="text-sm sm:text-base md:text-base text-gray-600 max-w-3xl mx-auto">
            Discover why Insytix Tech Institute is the preferred choice for tech education.
          </p>
        </div>

        {/* Responsive Grid: Image above on mobile, side by side on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Image Section - first on mobile */}
          <div className="order-1 lg:order-2 flex items-center justify-center">
            <div className="w-full max-w-md sm:max-w-lg md:max-w-xl bg-gray-200 rounded-lg p-4 flex items-center justify-center">
              <img
                src={aboutimg}
                alt="About Us"
                className="max-w-full max-h-[320px] object-contain rounded"
              />
            </div>
          </div>

          {/* Text Content - second on mobile */}
          <div className="order-2 lg:order-1">
            <h3 className="text-xl sm:text-2xl md:text-2xl font-bold text-gray-900 mb-6">
              Shaping Industry-Ready Professionals!
            </h3>
            <div className="space-y-4 text-gray-600 text-sm sm:text-base md:text-lg">
              <p>
                Founded with a vision to empower the next generation of innovators, INSYTIX Tech Institute has been a trusted destination for career-driven learners. Our mission is to transform aspiring students into confident, job-ready professionals through a blend of cutting-edge curriculum, hands-on learning, and real-world exposure.
              </p>
              <p>
                We have a highly trained technical team and domain experts to ensure that our programs remain aligned with the latest industry trends. From Software Development to Creative Design and Business Communication, our holistic training prepares students not just for their first job, but for long-term success in a dynamic technology landscape.
              </p>
              <ul className="list-disc list-inside pt-6 text-gray-600 text-sm sm:text-base md:text-lg space-y-1">
                <li>Expert-Led Training</li>
                <li>Industry Standard Coaching</li>
                <li>Practical & Project-Based</li>
                <li>Placement Opportunity</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
